import { motion } from 'motion/react';
import {useState, useEffect} from 'react'
import { useActionData } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {API_URL} from '../../config/api'

export default function Answers({answers, correctAnswer, setCorrectAnswer, setScoreRecebido, ticketId, emitirSom }){
    const [newAnswer, setNewAnswer] = useState(answers || []);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [letterAnswer, setLetterAnswer] = useState(null)
    const token = localStorage.getItem("token")
    const {user, setScore, logout} = useAuth()
    
    const validateAnswer = async (answerId) => {
        setSelectedAnswer(answerId);

        const dados = {
            "userId": user.id,
            "ticketsId": ticketId,
            "answerId": answerId
        };

        await fetch(`${API_URL}/user/answer`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(dados)
        })
        .then(response => {

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }
            if (response.status === 403) {
                    logout()
                    return
                }

            return response.json();
        })
        .then(data => {

            if (data.correct) {

                setCorrectAnswer(true);
                setScoreRecebido(data.score);
                setScore(data.scoreTotal)
                emitirSom("certo")
                

            } else {
                setCorrectAnswer(false);
                setNewAnswer(atual => shuffleAnswers(atual));
                emitirSom("errado")
            }
            

        })
        .catch(error => {
            console.log("Não foi possível.", error);
        });
    };

    const shuffleAnswers = (array) => {
        const novoArray = [...array];

        for (let i = novoArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));

            [novoArray[i], novoArray[j]] = [novoArray[j], novoArray[i]];
        }
        console.log(newAnswer.map(q => q.index));

        return novoArray;
    };

    // ANIMAÇÕES DAS RESPOSTAS
    const animacaoCerta = {
        backgroundColor: "var(--verde)",
        border: "1px solid var(--borda-verde)",
    };

    const animacaoErrada = {
        backgroundColor: "var(--fundo-vermelho)",
        border: "1px solid var(--vermelho)",
        x: [0, -10, 10, -10, 10, 0],
    };

    const handleOnHover = () =>{
        const audio = new Audio('/sounds/hover.mp3')
        audio.play()
    }

    return (
        <>
            {newAnswer.map((q) => (
            <motion.div
                whileHover={{
                    scale: 1.06
                }}
                onHoverStart={handleOnHover}

                animate={
                    selectedAnswer !== q.index
                        ? {}
                        : correctAnswer === true
                            ? animacaoCerta
                            : animacaoErrada
                }
                onAnimationComplete={() => {
                    if (!correctAnswer) {
                        setCorrectAnswer(null);
                    }
                }}

                key={q.index}
                className="flex opcao"
                onClick={() =>validateAnswer(q.index)}
            >

                <p>{q.answer}</p>
            </motion.div>

        ))}
        </>
    )
}